import { render, staticRenderFns } from "./yeGiveForm.vue?vue&type=template&id=d137c3dc&scoped=true"
import script from "./yeGiveForm.vue?vue&type=script&lang=js"
export * from "./yeGiveForm.vue?vue&type=script&lang=js"
import style0 from "./yeGiveForm.vue?vue&type=style&index=0&id=d137c3dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d137c3dc",
  null
  
)

export default component.exports